module.exports = __webpack_public_path__ + "d4d4e5618b1bef7fb9006043dade0706.pdf";